export default __webpack_public_path__ + "static/media/image.963b71e5.png";